export default "__VITE_ASSET__CdrxMaAf__"